<template>
  <div class="wrap">
    <div class="header">
      <div class="header-page-title">
        <p>{{header_title}}</p>
      </div>
    </div>
    <div class="main" id="main" ref="main">
      <p class="main_caption">完善基本信息</p>
      <div class="item-input" id="item-input-name">
        <div>
          <div>姓名<p>*</p></div>
          <el-input type="text" v-model="orderObj.customerName" @focus="nameBoxShow" @blur="nameBoxNoShow" maxlength="20"></el-input>
        </div>
        <div class="input_notice" v-if="nameFlag">
          <p>贷款人姓名应与上牌人一致</p>
        </div>
      </div>
      <div class="item-input">
        <div>
          <div>身份证号码<p>*</p></div>
          <el-input type="text" v-model="orderObj.customerIdCard" maxlength="18"/>
        </div>
      </div>
      <div class="item-input">
        <div>
          <div>上牌城市<p>*</p></div>
          <el-input type="text" v-model="orderObj.registrationCity" @input="trimOrderInfo" maxlength="16"/>
        </div>
      </div>
      <div class="item-input">
        <div>
          <div>银行卡号<p>*</p></div>
          <el-input type="number" v-model="orderObj.bankCardNumber" data-column="bankCardNumber" @focus="noticeSupportBankShow"
                    @blur="noticeSupportBankShow" pattern="[0-9]*" @input="limitMaxLength(19)" maxlength="19"/>
        </div>
        <div class="input_notice" v-if="supportBankShowFlag">
          <p>目前仅支持“工商银行、中国银行、建设银行、交通银行、兴业银行、光大银行、中信银行、广发银行”。</p>
        </div>
      </div>
      <div class="item-input">
        <div>
          <div>银行预留手机号<p>*</p></div>
          <el-input type="tel" v-model="orderObj.bankMobile" maxlength="11"/>
        </div>
      </div>
      <div class="item-input" id="item-input-vcode">
        <div>
          <div>验证码<p>*</p></div>
          <el-input type="number" v-model="orderObj.checkCode" data-column="checkCode" @input="limitMaxLength(6)" pattern="[0-9]*" maxlength="6"/>
          <button @click="getCode" v-html="vCodeStr"></button>
        </div>
      </div>
      <div class="page_notice" v-if="orderObj.loanAmount > 195000">
        <!--<div class="page_notice">-->
        <p><span>*</span>鉴于您申请的贷款额度大于19万5，请您准备好3个月以上的纸质流水证明 或 网银流水截图</p>
      </div>
      <div class="sub_button">
        <button @click="submitOrderInfo">提交</button>
      </div>
    </div>
    <div class="footer">
      <div>
        <p>江南银行分期业务由灿谷金服提供相关服务</p>
      </div>
    </div>
  </div>
</template>

<script>

  import {Toast, Indicator, MessageBox} from 'mint-ui'
  import common from '../utils/common'
  import qs from 'qs';

  export default {
    name: 'Lx_CollectData',
    data() {
      return {
        header_title: '江南银行',
        // 转回车和家页面地址
        backUrl: null,
        orderObj: {
          customerName: null,
          customerIdCard: null,
          registrationCity: null,
          bankCardNumber: null,
          bankMobile: null,
          checkCode: null,
          crmId: null,
          carTotalPrices: null, // 车价总额
          loanAmount: null, // 贷款金额
          checkCode: null

        },
        // 支持银行展示
        supportBankShowFlag: false,
        // 验证码

        vCodeStr: '获取验证码',
        timeCount: 60,
        timer: null,
        nameFlag:false
      }
    },
    mounted() {
      const that = this
      window.scrollTo(0, 0)
      that.$nextTick(function () {
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        });
        that.$axios.post('/crm/lx/getinfo', qs.stringify({'crmId': common.getUrlKey('id')})).then(function ({data}) {
          const { flag, backUrl, loanAmount, customerName, carModelId, carPrice, downPaymentRate, loanPeriod} = data.data
          Indicator.close();
          // 判断是否已申请
          if(data.code == '0') {
            that.backUrl = backUrl
            // 判断是否已申请
            if(flag == 1) {
              const router = that.$router;
              sessionStorage.setItem("loan_amount", Math.ceil(loanAmount))
              sessionStorage.setItem("backurl", backUrl)
              router.push({
                path: '/applyLxOne_Success',
                name: 'Lx_Success',
                params: {}
              })
              return
            }
            let carTotalPrices = Math.ceil(carPrice)
            if(!common.isEmpty(carModelId)) {
              carTotalPrices = 338000
              if(carModelId == 1) {
                carTotalPrices = 328000
              }
            }
            that.orderObj =Object.assign({}, that.orderObj, {
              crmId: common.getUrlKey('id'),
              customerName: customerName,
              loanAmount: Math.ceil(loanAmount), // 贷款金额
              carTotalPrices: carTotalPrices, // 车价总额
              downPaymentRatio: downPaymentRate, // 首付比例
              loanAmount: Math.ceil(loanAmount), // 贷款金额
              loanPeriod: loanPeriod, // 贷款期限
            })
          }else{
            Toast({
              message: res.data.msg,
              className: 'longMsgStyle'
            })
            return
          }
        }).catch(function (error) {
          Indicator.close();
          Toast({
            message: error.data.msg,
            className: 'longMsgStyle'
          })
          return
        })
      })
    },
    methods: {
      nameBoxShow (){
        this.nameFlag = true
      },
      nameBoxNoShow(){
        this.nameFlag = false
      },
      // 银行卡号输入focus
      noticeSupportBankShow() {
        this.supportBankShowFlag = !this.supportBankShowFlag
      },
      // 去空格
      trimOrderInfo() {
        let { registrationCity } = this.orderObj
        if(common.isEmpty(registrationCity)){
          this.orderObj.registrationCity = null
          return
        }
        this.orderObj.registrationCity = common.trimAll(registrationCity);
      },
      // input type = 'number' maxLength无效, 此方法代替
      limitMaxLength(maxlength) {
        if (!common.isEmpty(this.orderObj[event.target.dataset.column]) &&
          this.orderObj[event.target.dataset.column].length > maxlength) {
          this.orderObj[event.target.dataset.column] = this.orderObj[event.target.dataset.column].slice(0, maxlength)
        }
      },
      // 获取验证码
      getCode(e) {
        const that = this
        const { bankMobile } = this.orderObj
        if(common.isEmpty(bankMobile)) {
          Toast({
            message: '请输入银行预留手机号码',
            className: 'longMsgStyle'
          })
          return
        }
        if(bankMobile.length != 11) {
          Toast({
            message: '银行预留手机号码格式不正确',
            className: 'longMsgStyle'
          })
          return
        }
        let event = e.currentTarget
        event.disabled = true
        let data = {"mobile": bankMobile}
        this.$axios.get('/crm/lx/getcode?mobile='+ bankMobile).then(function (res) {
          if(res.data.code == '0') {
            that.vCodeStr = '(' + that.timeCount + 's)' + '重新获取'
            that.timer = setInterval(() => {
              that.timeCount--
              if (that.timeCount > 0) {
                that.vCodeStr = '(' + that.timeCount + 's)' + '重新获取'
              } else {
                clearInterval(that.timer); // 清除js定时器
                event.disabled = false;
                that.vCodeStr = '获取验证码';
                that.timeCount = 60; // 重置时间
              }
            }, 1000);
          }else{
            event.disabled = false;
          }
          Toast({
            message: res.data.msg,
            className: 'longMsgStyle'
          })
          return
        }).catch(function (error) {
          event.disabled = false;
          Toast({
            message: error.data.msg,
            className: 'longMsgStyle'
          })
          return
        });
      },

      // 提交订单信息
      submitOrderInfo() {
        const that = this
        const { customerName, customerIdCard, registrationCity,
          bankCardNumber, bankMobile, checkCode, loanAmount } = that.orderObj
        if(common.isEmpty(customerName)) {
          Toast({
            message: '请输入姓名',
            className: 'longMsgStyle'
          })
          return
        }
        if(common.isEmpty(customerIdCard)) {
          Toast({
            message: '请输入身份证号',
            className: 'longMsgStyle'
          })
          return
        }
        if(customerIdCard.length != 18) {
          Toast({
            message: '身份证号格式不正确',
            className: 'longMsgStyle'
          })
          return
        }
        if(common.isEmpty(registrationCity)) {
          Toast({
            message: '请输入上牌城市',
            className: 'longMsgStyle'
          })
          return
        }
        if(common.isEmpty(bankCardNumber)) {
          Toast({
            message: '请输入银行卡号',
            className: 'longMsgStyle'
          })
          return
        }
        if(bankCardNumber.length < 16) {
          Toast({
            message: '银行卡号格式不正确',
            className: 'longMsgStyle'
          })
          return
        }
        if(common.isEmpty(bankMobile)) {
          Toast({
            message: '请输入银行预留手机号码',
            className: 'longMsgStyle'
          })
          return
        }
        if(bankMobile.length != 11) {
          Toast({
            message: '银行预留手机号码格式不正确',
            className: 'longMsgStyle'
          })
          return
        }
        if(common.isEmpty(checkCode)) {
          Toast({
            message: '请输入验证码',
            className: 'longMsgStyle'
          })
          return
        }
        if(checkCode.length != 6) {
          Toast({
            message: '请输入验证码格式不正确',
            className: 'longMsgStyle'
          })
          return
        }
        let tipStr = '请确认内容正确？'
        MessageBox.confirm(tipStr).then(action => {
          Indicator.open({
            text: '加载中...',
            spinnerType: 'fading-circle'
          });
          this.$axios({
            method: 'post',
            url: '/crm/lx/checkcode',
            data: that.orderObj,
            headers: {
              'Content-Type': 'application/json',
            },
          }).then(function (res) {
            Indicator.close();
            const router = that.$router;
            sessionStorage.setItem("loan_amount", loanAmount)
            sessionStorage.setItem("backurl", that.backUrl)
            router.push({
              path: '/applyLxOne_Success',
              name: 'Lx_Success',
              params: {}
            })
          }).catch(function (error) {
            Indicator.close();
            Toast({
              message: error.data.msg,
              className: 'longMsgStyle'
            })
            return
          })
        }).catch(() => {
          return
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

  .longMsgStyle {
    margin: 0 auto;
    width: 60%;
    left: 0 !important;
    right: 0 !important;
    transform: translate(-0%, -50%) !important;
  }

  .wrap {
    background: #fff;
  }

  p {
    margin: 0;
  }

  .header {
    margin: 0 auto;
    padding: 0;
    width: 7.50rem;
  }

  .header-page-title {
    margin: 0;
    padding: 0;
    height: 1.28rem;
  }
  .header-page-title > p {
    padding-top: 0.20rem;
    width: 100%;
    font-size: 0.42rem;
    font-weight: 600;
    line-height: 1.08rem;
    color: #222;
    text-align: center;
  }
  .wrap > .main {
    padding-top: 0.6rem;
    margin: 0 auto;
    width: 7.5rem;
  }

  .wrap > .main > .main_caption {
    margin: 0 auto;
    margin-bottom: 0.54rem;
    width: 6.65rem;
    font-size: 0.46rem;
    font-weight: 600;
    line-height: 0.65rem;
    color: #000000;
    letter-spacing: -0px;
    text-align: left;
  }

  .wrap > .main > .item-input {
    border-bottom: 0.01rem solid #F0F0F0;
    width: 100%;
  }

  .wrap > .main > .item-input > div {
    position: relative;
    margin: 0 auto;
    width: 6.65rem;
    height: 0.99rem;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
  }

  .wrap > .main > .item-input > div > div:first-child {
    position: absolute;
    left: 0;
    top: 0;
    font-size: 0.28rem;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    line-height: 0.99rem;
    color: #000000;
    font-weight: 600;
    letter-spacing: -0px;
    opacity: 0.6;
    text-align: left;
    z-index: 3;
  }

  .wrap > .main > .item-input > div > div:first-child > p {
    height: 100%;
    line-height: 0.99rem;
    font-size: 0.30rem;
    color: #f07676;
    display: flex;
    align-items: flex-start;
  }

  .wrap > .main > .item-input > div > .el-input {
    width: 6.65rem;
    height: 0.99rem;
    line-height: 0.40rem;
    font-size: 0.28rem;
    color: #000000;
    letter-spacing: -0px;
    border-width: 0;
    border-radius: 0;
    text-align: right;
    outline: 0;
  }


  .wrap > .main > .item-input > div .el-input__inner {
    padding: 0 2.2rem;
    padding-right: 0;
    border: 0;
    border-radius: 0;
    height: 0.99rem;
    line-height: 0.40rem;
    font-size: 0.28rem;
    color: #000;
    text-align: right;
    opacity: 0.6;
  }

  .wrap > .main > .item-input > .input_notice {
    padding: 0.13rem 0.15rem;
    width: 6.82rem;
    background: #88C5FF;
    border-radius: 0.06rem;
  }

  .wrap > .main > .item-input > .input_notice > p {
    width: 100%;
    background: #88C5FF;
    border-radius: 0.06rem;
    font-size: 0.26rem;
    line-height: 0.36rem;
    color: #000000;
    letter-spacing: -0px;
    text-align: left;
  }

  #item-input-vcode > div > .el-input > .el-input__inner {
    padding-left: 1.5rem;
    padding-right: 2.3rem;
  }

  #item-input-vcode > div > button {
    padding: 0;
    position: absolute;
    top: 19%;
    left: 4.73rem;
    padding: 0 0.125rem;
    height: 0.6rem;
    background: #FFFFFF;
    border: 0.02rem solid #2594FF;
    border-radius: 0.06rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.24rem;
    color: #2594FF;
    outline: 0;
  }

  .page_notice {
    margin: 0 auto;
    margin-top: 0.6rem;
    width: 6.76rem;
    display: flex;
    flex-flow: row nowrap;
  }

  .page_notice > p {
    opacity: 0.6;
    font-size: 0.22rem;
    color: #000000;
    letter-spacing: -0px;
    text-align: left;
  }

  .page_notice span {
    font-size: 0.24rem;
    color: #f07676;
    letter-spacing: -0px;
    text-align: left;
  }

  .sub_button {
    margin-top: 1.28rem;
    width: 100%;
    text-align: center;
  }

  .sub_button > button {
    padding: 0;
    width: 5.61rem;
    height: 0.9rem;
    background: #2594FF;
    border-radius: 6px;
    border-width: 0;
    font-size: 0.32rem;
    color: #FFFFFF;
    letter-spacing: -0px;
    text-align: center;
  }

  .wrap > .footer {
    margin-top: 0.95rem;
    padding-bottom: 0.81rem;
    font-size: 0;
    text-align: center;
  }

  .wrap > .footer > img {
    margin: 0 auto;
    width: 3.24rem;
    height: 0.76rem;
  }

  .wrap > .footer > div > p {
    opacity: 0.6;
    font-size: 0.22rem;
    color: #000000;
    letter-spacing: -0px;
    text-align: center;
    line-height: 0.32rem;
  }

  /* input type = 'number' PC端去除上下箭头 */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
</style>



// WEBPACK FOOTER //
// src/components/Lx-CollectData.vue